import { BusinessProfileUpdateStrategy } from '../../../../providers/BusinessProfileProvider';

export default {
  modals: {
    update_strategy: {
      title: 'Welke locaties moeten worden bijgewerkt?',
      form: {
        update_strategy: {
          options: {
            [BusinessProfileUpdateStrategy.All]: 'Al mijn locaties',
            [BusinessProfileUpdateStrategy.Current]: 'Alleen huidige locatie',
          },
        },
      },
      buttons: {
        confirm: 'Bevestigen',
      },
    },
  },
  toasts: {
    error: 'Er is iets misgegaan, probeer opnieuw of neem contact op met technische support',
    success: 'Wijzigingen zijn succesvol opgeslagen!',
  },
};
